import { Ionicons } from '@expo/vector-icons';
import React from 'react';

import { useTheme } from '@/components/theme-provider';
import type { IconName } from '@/types/icons';

export interface IconProps {
	name?: IconName;
	source?: IconName;
	size?: number;
	color?: string;
	style?: any;
}

export const Icon: React.FC<IconProps> = ({ name, source, size = 24, color, style }) => {
	const theme = useTheme();
	const iconName = name || source;

	return (
		<Ionicons
			name={iconName}
			size={size}
			color={color || theme.colors.onSurface}
			style={style}
		/>
	);
};
